const MultiSelectFieldController = function ($rootScope, $scope, $controller, $timeout, coreConstant, formViewerConstant, formComponentUtil, coreMediator, formMediator, localization, uuidUtil) {

    const splitKey = '::';
    const timeoutList = [];
    const dataSetImmediateLoad = true;
    const preventDataSetLoadIfConfigurableComponent = false;

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}), $controller('baseDataSetFormComponentController', {$scope: $scope}));

    this.promptValue = '';
    this.filterTextPrompt = '';
    this.itemName = `Multi Select ${uuidUtil.generateUUID()}`;

    this.$onInit = function () {
        this.onInitDataSetComponent(dataSetImmediateLoad, preventDataSetLoadIfConfigurableComponent).then(() => {
        });

        this.dropdownSelectedValue = null;
        this.formStructure = formMediator.getFormStructure(this.fieldStructure.rootFormId);
    };

    this.filterToolTip = function (items) {
        let tooltipArr = _.map(items, function (item) {
            return item.description;
        });
        let toolTipValue = _.replace(tooltipArr.toString(), new RegExp(',', 'g'), ', ');
        this.fieldStructure.dynamicProperties.tooltip = {
            type: '',
            message: toolTipValue
        };
    };

    this.handleChange = function () {

    };

    this.handleMultiSelectChange = function (selectedValueList) {
        let fieldValue = '';
        _.forEach(selectedValueList, function (item) {
            fieldValue += (fieldValue==''?'':splitKey) + item.value;
        });

        if (this.fieldStructure.fieldModel) {
            this.fieldStructure.fieldModel.value = fieldValue;
        } else {
            this.fieldStructure.fieldModel = {
                value: fieldValue
            };
        }

        if (!_.isNil(fieldValue)) {
            this.filterToolTip(selectedValueList);
        } else {
            this.fieldStructure.dynamicProperties.tooltip = {
                type: '',
                messages: ''
            };
        }

        this.fieldStructure.hasLocalChanges = true;
        formMediator.handleFieldChange(this.fieldStructure.parentForm.id, this.fieldStructure, this.resetFieldValue.bind(this), this.updateOriginalFieldValue.bind(this));
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, (event, itemName) => {
        if (this.itemName === itemName) {
            this.fieldStructure.dynamicProperties.tooltip.message = '';
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, (event, itemName, searchText) => {
        if (this.itemName === itemName) {
            if (this.supportSearch && _.size(searchText) >= this.minimumSearchCharacters) {
              this.setSearchText(searchText);
              this.loadDataSet(dataSetImmediateLoad);
            }
        }
    });

};

angular.module('umFormViewer')
    .controller('multiSelectFieldController', MultiSelectFieldController);
